import React from 'react'
import NoAccess from 'images/no_access.svg'

import './style.css'

const ForbiddenAccess = () => (
  <div className="forbidden-access-wrapper">
    <img src={NoAccess} alt="Forbidden access"/>
    <div className="forbidden-access-text-area">
      <p className="forbidden-access-text forbidden-access-primary-text">
        <strong>Sorry, it looks like you don’t have permission to view this page.</strong>
      </p>
      <p className="forbidden-access-text forbidden-access-secondary-text">
       If you want access, please ask one of your team admins to give you permission.
      </p>
    </div>
  </div>
)

export default ForbiddenAccess